import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const companyDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/companies/$companyId",
  component: lazyRouteComponent(() => import("./company-detail.page.js"), "CompanyDetailPage"),
});
